import { SVGIcon } from '@superops/super-icons';
import { TextStyle } from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

function EfficiencyCell(props) {
  const intl = useIntl();
  const { cell } = props;
  const { value, row, column } = cell || {};

  if (row?.original?.[column?.id] === null) {
    return (
      <div className="flex actr g5">
        <TextStyle variation="subdued">
          <FormattedMessage id="app.noData.message" />
        </TextStyle>
      </div>
    );
  }

  const cellValue = Number(value);

  if (cellValue > 0)
    return (
      <div className="flex actr g5">
        <SVGIcon size="sm" name="Increased" color="#48AC3D" />
        <TextStyle>
          {`${value} % ${getTranslatedText(intl, 'common.label.aboveAverage')}`}
        </TextStyle>
      </div>
    );
  if (cellValue < 0)
    return (
      <div className="flex actr g5">
        <SVGIcon size="sm" name="Decreased" color="#D75656" />
        <TextStyle>
          {`${Math.abs(value)} % ${getTranslatedText(
            intl,
            'common.label.belowAverage'
          )}`}
        </TextStyle>
      </div>
    );
  if (cellValue === 0)
    return (
      <div className="flex actr g5">
        <SVGIcon size="sm" name="Integrate" color="blue" />
        <TextStyle>
          <FormattedMessage id="common.label.sameasAverage" />
        </TextStyle>
      </div>
    );
}

export default EfficiencyCell;
